export type Admin = {
  id: number;
  corporationId: number;
  email: string;
  lastName: string;
  middleName: string;
  firstName: string;
  kanaLastName: string;
  kanaMiddleName: string;
  kanaFirstName: string;
  latinLastName: string;
  latinMiddleName: string;
  latinFirstName: string;
  division: string;
  region: string;
  language: string;
  activatedAt: string;
};

const defaultAdmin: Admin = {
  id: 0,
  corporationId: 0,
  email: '',
  firstName: '',
  middleName: '',
  lastName: '',
  kanaFirstName: '',
  kanaMiddleName: '',
  kanaLastName: '',
  latinFirstName: '',
  latinMiddleName: '',
  latinLastName: '',
  division: '',
  region: '',
  language: 'ja-JP',
  activatedAt: '',
};

export const adminFactory = (adminAttrs?: {
  [P in keyof Admin]?: Admin[P];
}): Admin => ({
  ...defaultAdmin,
  ...adminAttrs,
});
